export default {
  failed_to_open: 'Nie udało się otworzyć onboardingu dla tej restauracji. Spróbuj ponownie.',
};
